/** @format */

import { Inject, Injectable } from '@angular/core';
import { chain } from '@core/chain';
import { UtilityService, WINDOW } from '@shared/utils/services';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class PayerAuthenticationService {
	private customSubject = new Subject<void>();
	public customObservable = this.customSubject.asObservable();
	constructor(
		@Inject(WINDOW) private window: Window,
		private utilityService: UtilityService
	) {}

	public authenticatePayment(
		checkoutKey: string,
		wcsCluster: number,
		authEnrollment: any,
		orderId,
		piId
	) {
		const formField = {
			PaReq: authEnrollment.pa_req,
			MD: authEnrollment.x_id,
			TermUrl: this.buildTermUrl(checkoutKey, wcsCluster, orderId, piId)
		};

		// Generate a new UUID
		const uuid = this.utilityService.generateUUID();

		// Set a unique <iframe> Name
		const iFrameName = `iframeName${uuid}`;

		// Set a unique <iframe> ID
		const iFrameId = `iframeId${uuid}`;

		// Set a unique <form> ID
		const formId = `formId${uuid}`;

		const form = document.createElement('form');
		form.setAttribute('id', formId);
		form.setAttribute('target', iFrameName);
		form.setAttribute('method', 'post');
		form.setAttribute('style', 'display:none;');
		form.setAttribute('action', authEnrollment.acs_url);

		const iframe = document.createElement('iframe');
		iframe.setAttribute('src', authEnrollment.acs_url);
		iframe.setAttribute('name', iFrameName);
		iframe.setAttribute('id', iFrameId);
		iframe.setAttribute('style', 'display:none;');

		document.getElementsByTagName('body')[0].appendChild(iframe);
		document.getElementsByTagName('body')[0].appendChild(form);

		Object.entries(formField).forEach(([key, val]) => {
			const inputval = val as string;
			const hiddenInput = document.createElement('input');
			hiddenInput.type = 'hidden';
			hiddenInput.name = key;
			hiddenInput.value = inputval;
			document.getElementById(`formId${uuid}`).appendChild(hiddenInput);
		});

		// Add the load callback
		document.getElementById(iFrameId).onload = this.secureAuthCallback(iFrameId);

		// Submit the <form>
		const myForm = document.getElementById(formId) as HTMLFormElement;
		myForm.submit();
	}

	private buildTermUrl(
		checkoutKey: string,
		wcsCluster: number,
		inOrderId,
		inPaymentInstructionId
	) {
		const queryParams = `storeId=${chain.storeId}&orderId=${inOrderId}&piId=${inPaymentInstructionId}&cId=${wcsCluster}`;
		return `https://${this.window.location.hostname}/api/v1/checkouts/${checkoutKey}/payment/payment-processor/cybersource/auth-enrollment?${queryParams}`;
	}

	private secureAuthCallback(iFrameId) {
		// gets called multiple times. cannot do typcial error scenario.
		return () => {
			// Return an anonymous function so it isn't executed immediately
			const iframe = document.getElementById(iFrameId) as HTMLFrameElement;
			const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
			const customerAuthReceipt = innerDoc.getElementById('CustomerAuthReceipt');
			if (customerAuthReceipt !== undefined) {
				this.customSubject.next();
			} else {
				return false;
			}
		};
	}
}
